import {useState, useEffect} from "react";
import {useLocation, useParams} from "react-router-dom";
import {ETAPService} from "abastecemento/service";
import {useETAPData} from "../hooks/ETAPData";
import {PageLayout} from "base/layout";
import {ETAPSubPageMenu} from "../menu";
import {useAppConfig} from "base/provider";
import {EntityPrintPDFAction} from "base/entity";

const ViewETAPPage = () => {
    const {setSubpagePath, setModuleActions} = useAppConfig();

    const {idEtap} = useParams();
    const [etap, setEtap] = useState(null);
    const location = useLocation();
    const {getEntityData} = useETAPData();

    useEffect(() => {
        ETAPService.get(idEtap).then(data => {
            setEtap(data);
            setSubpagePath([
                {name: "Listado de ETAP", path: "etaps"},
                {
                    name: data.nome || data.codigo || data.id,
                    path: `${data.id}/summary`,
                },
            ]);
            setModuleActions([
                <EntityPrintPDFAction entityData={getEntityData(data)} />,
            ]);
        });
        return () => {
            setEtap(null);
            setSubpagePath([]);
            setModuleActions([]);
        };
    }, [idEtap, location.state?.lastRefreshDate]);

    return (
        etap && (
            <PageLayout
                menu={<ETAPSubPageMenu etap={etap} />}
                context={[etap]}
                subPage={true}
            />
        )
    );
};

export default ViewETAPPage;
